module.exports = ".errorInput {\r\n    border: 1px solid #dd2d2d;\r\n}\r\n\r\n.rutlabel {\r\n    padding-top: 15px\r\n}"